<template>
    <div class="fluid">
        <h1 class="app-title">Painel do Tesoureiro – Dashboard</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="Requisições" active  @click="mudarAba(0)" v-if="admin || tesoureiro">
                            <TabelaAbaRequisicoes
                                    :loading="this.$refs.loading" />
                        </b-tab>
                        <b-tab title="Financeiro" @click="mudarAba(1)" v-if="admin || tesoureiro">
                            <TabelaAbaFinanceiro
                                    :loading="this.$refs.loading" />
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
        <CompLoading ref="loading"></CompLoading>
        
    </div>
</template>

<script>
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import TabelaAbaRequisicoes from "./components/TabelaAbaRequisicoes";
    import TabelaAbaFinanceiro from "./components/TabelaAbaFinanceiro";
    
    export default {
        components: {
        TabelaAbaRequisicoes,
        TabelaAbaFinanceiro
},
        data() {
            return {
                urlApi: null,
                token: null,
                tabIndex: 0,
                admin: false,
                procurador: false,
                tesoureiro: false,
                load: false
            }
        },
        methods: {
            mudarAba(index) {
                this.tabIndex = index;
            },
            
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let userData = JSON.parse(this.$store.getters.getUser);
            if (userData.groups) {
                for (const element of userData.groups) {
                    if(element == 'SFEPGE-ADMINISTRADOR') {
                        this.admin = true;
                    } else if(element == 'SFEPGE-TESOUREIRO') {
                        this.tesoureiro = true;
                }
            }
        }
        },
        
    }
</script>